:host {
    @include typo-ws-h4;

    display: block;
    scroll-snap-align: center;
    cursor: pointer;

    ::slotted(span) {
        color: $color-grey-02-steel;
        font-size: 0.8em;
    }
}

:host([active]) {
    color: $color-red;

    ::slotted(span) {
        color: inherit;
    }
}
